import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getProductos,
  deleteProducto,
  getProductoById,
} from "../helpers/rutaProductos";
import ModalProducto from "./ModalProducto";
// import "../css/tableclientes.css"; // si lo usás, dejalo

const COLS = { acciones: 90, nro: 80, producto: 320 };
const cellTruncate = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };

const TableProductos = () => {
  const [state, setState] = useState({ productos: [], loading: true, error: "" });
  const [producto, setProducto] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => { consultaProductos(); }, []);

  const consultaProductos = async () => {
    try {
      const datos = await getProductos(); // ← ya es un array normalizado
      console.log("📦 Productos:", datos);
      // seguridad: si por alguna razón no es array, lo fuerzo a []
      const lista = Array.isArray(datos) ? datos : (Array.isArray(datos?.productos) ? datos.productos : []);
      setState({ productos: lista, loading: false, error: "" });
    } catch (e) {
      console.error("❌ getProductos:", e);
      setState(s => ({ ...s, loading: false, error: e?.message || "Error al cargar productos" }));
    }
  };

  const handleClose = () => { setShow(false); consultaProductos(); };
  const handleShow  = () => setShow(true);

  const modificaProducto = async (id) => {
    try {
      const resp = await getProductoById(id);
      if (resp?.ok) {
        setProducto(resp.producto);
        handleShow();
      } else {
        console.error("❌ Error al obtener producto:", resp?.error || resp);
      }
    } catch (e) {
      console.error("❌ getProductoById:", e);
    }
  };

  const eliminarProducto = async (id) => {
    if (!window.confirm("¿Está seguro que desea borrar el producto?")) return;
    try {
      await deleteProducto(id);
      consultaProductos();
    } catch (e) {
      console.error("❌ deleteProducto:", e);
    }
  };

  if (state.loading) return <div className="p-3">Cargando productos…</div>;
  if (state.error)   return <div className="p-3 text-danger">{state.error}</div>;

  const rows = state.productos
    .filter(p => p?.activo ?? true)
    .sort((a,b) => (a.producto || "").localeCompare(b.producto || "", "es", { sensitivity: "base" }));

  return (
    <div className="table-container">
      <div className="col-12 mt-4" />
      <div>
        <Table
          striped
          bordered
          hover
          style={{ tableLayout: "fixed", width: "100%" }}  // anchos fijos
        >
          <thead>
            <tr className="header">
              <th style={{ width: COLS.acciones }}>Acciones</th>
              <th style={{ width: COLS.nro }}>Nro</th>
              <th style={{ width: COLS.producto }}>Producto</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={3} className="text-center">No hay productos.</td></tr>
            ) : rows.map((p) => (
              <tr key={p._id}>
                <td style={{ width: COLS.acciones, whiteSpace: "nowrap" }}>
                  <div style={{ display: "flex", gap: 8, flexWrap: "nowrap", justifyContent: "center" }}>
                    <button className="btn btn-primary" onClick={() => modificaProducto(p._id)}>
                      <i className="fa fa-pencil-square-o" aria-hidden="true" />
                    </button>
                    <button className="btn btn-danger" onClick={() => eliminarProducto(p._id)}>
                      <i className="fa fa-trash-o" aria-hidden="true" />
                    </button>
                  </div>
                </td>
                <td style={{ width: COLS.nro }}>{p.codpro}</td>
                <td style={{ width: COLS.producto, textAlign: "left", ...cellTruncate }}>{p.producto}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <ModalProducto show={show} handleClose={handleClose} producto={producto} />
    </div>
  );
};

export default TableProductos;
